Auth = require 'app/scripts/db/auth'
Alerts = require 'app/scripts/views/lib/alerts'
Dates = require 'app/scripts/lib/dates'
LegacyPowerUps = require 'app/scripts/data/legacy-power-ups'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
WindowSize = require 'app/scripts/lib/window-size'
_ = require 'underscore'
template = require 'app/scripts/views/templates/date_picker'
{ track, trackUe } = require '@trello/analytics'
moment = require 'moment'
Pikaday = require 'pikaday'
Storage = require 'app/scripts/lib/storage'
l = require 'app/scripts/lib/localize'
{ dontUpsell } = require '@trello/config'
{ featureFlagClient } = require '@trello/feature-flag-client'

getPikadayStrings = ->
  previousMonth: l('prev month button text')
  nextMonth: l('next month button text')
  months: moment.months()
  weekdays: moment.weekdays()
  weekdaysShort: moment.weekdaysMin()

timeFormat = 'LT'
parseFormat = [timeFormat, 'h:mm A']
isTimeStringValid = (string) -> moment(string, parseFormat).isValid()

# values are in minutes for custom due date reminders
customReminderSettings = -> [
  { name: 'no', text: l('due-date-custom-reminder.none'), value: -1 },                                       # no reminder
  { name: 'at time of due date', text: l('due-date-custom-reminder.at-time-of-due-date'), value: 0 },          # 0 minutes
  { name: '5 minutes before', text: l('due-date-custom-reminder.5-minutes-before'), value: 5 },                # 5 minutes
  { name: '10 minutes before', text: l('due-date-custom-reminder.10-minutes-before'), value: 10 },             # 10 minutes
  { name: '15 minutes before', text: l('due-date-custom-reminder.15-minutes-before'), value: 15 },             # 15 minutes
  { name: '1 hour before', text: l('due-date-custom-reminder.1-hour-before'), value: 60 },                     # 1 hour
  { name: '2 hours before', text: l('due-date-custom-reminder.2-hours-before'), value: 2 * 60 },               # 2 hours
  { name: '1 day before', text: l('due-date-custom-reminder.1-day-before'), default: true, value: 24 * 60 },   # 1 day
  { name: '2 days before', text: l('due-date-custom-reminder.2-days-before'), value: 2 * 24 * 60 }             # 2 days
]

defaultReminder = -> customReminderSettings().find((reminder) => reminder.default).value

module.exports = class DatePickerView extends View
  viewTitleKey: 'change due date'
  tagName: 'form'
  className: 'dpicker-widget u-clearfix'

  events:
    'click .js-remove-date': 'removeDueDate'
    'input .js-dpicker-time-input': 'validateTimeInput'
    'change .js-dpicker-time-input': 'normalizeTimeInput'
    'click a[href="/business-class"]': ->
      track('Card Detail', 'Click Business Class Link', 'Date Picker PopOver')
    'submit': (e) ->
      e.preventDefault()
      dueDateMoment = @getSelectedDueDateMoment()

      reminderVal = parseInt(@$('.js-custom-reminder').val())
      reminderInt = if isNaN(reminderVal) then defaultReminder() else reminderVal
      @submitDueDate(dueDateMoment, reminderInt)

    'click .js-enable-calendar-powerup': (e) ->
      e.preventDefault()
      @enableCalendarPowerUp()

  initialize: ->
    @listenTo @model.getBoard(), 'change:powerUps', @renderCalendarPowerUp

  getSelectedDueDateMoment: ->
    date = @picker.getMoment()
    if !date.isValid()
      return null

    # Pikaday requires a single date format, and will parse it strictly (which
    # is good). However, this means an entry like '2/14/15' will parse as
    # '02/14/0015', which isn't great.
    if date.year() < 1000
      date.add(2000, 'years')

    time = @selectedTimeMoment()
    date
    .hour time.hour()
    .minute time.minute()

  submitDueDate: (dueDateMoment, reminder) ->
    if dueDateMoment?
      @setDueDate(dueDateMoment.toDate(), reminder)
    else
      @removeDueDate()

  setDueDate: (date, reminder) =>
    @trackSetDueDate(date, reminder)

    DatePickerView.lastDueDate = date
    Storage.set("lastDueDateReminder_#{Auth.myId()}", reminder)

    data = { 'due': date.getTime(), 'dueReminder': reminder }
    if @options.onError?
      @model.update(data, @options.onError)
    else
      @model.update(data)
    PopOver.hide()

  removeDueDate: ->
    @trackRemoveDueDate()

    if @model.get('due')
      @model.update({ 'due': null, 'dueReminder': null })
    PopOver.hide()

  trackSetDueDate: (date, reminder = defaultReminder()) ->
    category = @options.trackingCategory
    context = @trackingContext()

    prepObject = "on card"
    reminderName = customReminderSettings().find((opt) => opt.value == reminder).name
    prepObject = "with #{reminderName} custom notification"

    indObj = if !@model.getDueDate()?
      'that did not have a due date'
    else if @model.getDueDate()?.getTime() == date.getTime()
      'that had the same due date'
    else
      'that had a different due date'

    trackUe(category, 'saves', 'due date', prepObject, indObj, 'by clicking save button in the due date popover', context)

  trackRemoveDueDate: ->
    category = @options.trackingCategory
    context = @trackingContext()

    trackUe(category, 'removes', 'due date', 'from card', '', 'by clicking remove button in the due date popover', context)

  trackingContext: ->
    cardId: @model.id
    boardId: @model.getBoard()?.id
    teamId: @model.getBoard()?.getOrganization()?.id

  renderCalendarPowerUp: ->
    $show = @$('.js-cal-enabled').addClass('hide')
    $cal = @$('.js-enable-cal').addClass('hide')

    board = @model.getBoard()
    calendarEnabled = board.isPowerUpEnabled('calendar')
    showCalendar = board.owned() && !calendarEnabled

    if calendarEnabled
      $show.removeClass('hide')
    else if showCalendar
      $cal.removeClass('hide')
    return

  getSelectReminderSetting: ->
    dueReminder = @model.get('dueReminder')
    reminderSetting = if dueReminder? then dueReminder else Storage.get("lastDueDateReminder_#{Auth.myId()}")
    return if reminderSetting? then reminderSetting else defaultReminder()

  vigor: @VIGOR.NONE
  renderOnce: ->
    board = @model.getBoard()

    tomorrowAtNoon = moment().startOf('day').add(1, 'days').hour(12).toDate()
    dueDate = @model.getDueDate() ? DatePickerView.lastDueDate ? tomorrowAtNoon

    @$el.html template({
      canChangePowerUps: board.owned(),
      canEnableAdditionalPowerUps: board.canEnableAdditionalPowerUps(),
      upsellEnabled: !dontUpsell
      customReminderSettings: customReminderSettings()
      selectedReminderSetting: @getSelectReminderSetting()
    })

    @picker = new Pikaday
      field: @$('.js-dpicker-date-input')[0]
      container: @$('.js-dpicker-cal')[0]
      bound: false
      format: 'l'
      firstDay: moment.localeData().firstDayOfWeek()
      i18n: getPikadayStrings()
      keyboardInput: false

    @picker.setDate dueDate

    @$timeInput().val moment(dueDate).format(timeFormat)

    @renderCalendarPowerUp()

    @

  validateTimeInput: ->
    @$timeInput().toggleClass 'input-error', !@isTimeInputValid()

  normalizeTimeInput: ->
    @$timeInput().val @selectedTimeMoment().format(timeFormat)
    @validateTimeInput()

  selectedTimeMoment: ->
    if @isTimeInputValid()
      moment(@$timeInput().val(), parseFormat)
    else
      moment().hours(12).minutes(0)

  $timeInput: -> @$('.js-dpicker-time-input')

  isTimeInputValid: -> isTimeStringValid @$timeInput().val()

  enableCalendarPowerUp: ->
    idCalendar = LegacyPowerUps.calendar
    @model.getBoard().enablePlugin(idCalendar)
      .catch (err) =>
        @model.getBoard().disablePlugin(idCalendar)
        if Util.isJsonString(err.textStatus) && JSON.parse(err.textStatus).error == 'PLUGIN_NOT_ALLOWED'
          Alerts.show('plugin not allowed', 'error', 'addpluginerror', 4000)
        else
          Alerts.show('could not add plugin', 'error', 'addpluginerror', 2000)
    track "Card Detail", "Enable Calendar via Due Date Menu"
    trackUe('card detail', 'enables', 'Power-Up', '', '', 'due date', idCalendar)
    return
